import { SINGLE_COUNTRY } from '@/config/singleCountry'

// 单国(CIV)下加密彩 TRON/ETH/BNB 全部下线:加密家族置空 → cryptoLotteryFamily 恒 null,
// 下游加密 UI/筛选自动静默。多国扩展:SINGLE_COUNTRY 置 null 即恢复 ['tron','eth','bnb']。
const CRYPTO_FAMILIES = SINGLE_COUNTRY ? [] : ['tron', 'eth', 'bnb']
const UNAVAILABLE_FLAG_KEYS = [
  'mock',
  'mockMode',
  'mock_mode',
  'mockFallback',
  'mock_fallback',
  'stub',
  'fallback',
  'fallbackUsed',
  'fallback_used',
  'dataUnavailable',
  'data_unavailable',
  'readOnly',
  'readonly',
  'read_only',
  'readOnlyQuery',
  'read_only_query',
  'readOnlyMode',
  'read_only_mode',
  'readOnlyAction',
  'read_only_action',
  'readFailure',
  'read_failure',
  'readFailed',
  'read_failed',
  'readUnavailable',
  'read_unavailable',
  'readBlocked',
  'read_blocked',
  'technicalError',
  'technical_error',
  'technicalException',
  'technical_exception',
  'technicalMarker',
  'technical_marker',
  'backendFailure',
  'backend_failure',
  'unimplemented',
  'notImplemented',
  'not_implemented',
  'notSupported',
  'not_supported',
  'unsupported',
  'queryOnly',
  'query_only',
  'onlyQuery',
  'only_query',
  'blocked',
  'block',
  'notConnected',
  'not_connected',
  'routeUnavailable',
  'route_unavailable',
  'backendBlocked',
  'backend_blocked',
  'failClosed',
  'fail_closed',
  'paymentBackendBlocked',
  'payment_backend_blocked',
  'paymentStatusUnconfirmed',
  'payment_status_unconfirmed',
  'actionBlocked',
  'action_blocked',
  'writeBlocked',
  'write_blocked',
  'falseProof',
  'false_proof',
  'needLogin',
  'need_login'
]
const UNAVAILABLE_TEXT_KEYS = [
  'status',
  'state',
  'result',
  'code',
  'errorCode',
  'msg',
  'message',
  'reason',
  'errorMsg',
  'errorMessage'
]
const PAYMENT_STATUS_KEYS = [
  'paymentStatus',
  'payment_status',
  'payStatus',
  'pay_status'
]
const UNAVAILABLE_PROOF_KEYS = [
  'writeProof',
  'write_proof',
  'lotteryProof',
  'lottery_proof',
  'betProof',
  'bet_proof',
  'orderProof',
  'order_proof',
  'proof'
]

function normalizedType(type) {
  return String(type || '').trim().toLowerCase()
}

function hasOwn(source, key) {
  return Object.prototype.hasOwnProperty.call(source, key)
}

function markerToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function isFalseLike(value) {
  if (value === false || value === 0) return true
  return ['false', '0', 'no', 'off'].includes(markerToken(value))
}

function isUnavailableToken(value) {
  const token = markerToken(value)
  return !!token && (
    [
      'stub',
      'mock',
      'fallback',
      'fallback_used',
      'fallback-used',
      'fallback used',
      'mock_fallback',
      'mock-fallback',
      'mock fallback',
      'fail',
      'failed',
      'failure',
      'error',
      'false',
      '-1',
      '400',
      '401',
      '403',
      '404',
      '500',
      'rejected',
      'unavailable',
      'disabled',
      'read_only',
      'read_only_query',
      'read-only-query',
      'read only query',
      'readonly',
      'readonlyquery',
      'read only',
      'read-only',
      'read_failure',
      'read-failure',
      'read failure',
      'readfailed',
      'read_failed',
      'read-failed',
      'read failed',
      'readblocked',
      'read_blocked',
      'read-blocked',
      'read blocked',
      'readunavailable',
      'read_unavailable',
      'read-unavailable',
      'read unavailable',
      'technical_error',
      'technical-error',
      'technical error',
      'technicalerror',
      'technical_exception',
      'technical-exception',
      'technical exception',
      'technicalexception',
      'technical_marker',
      'technical-marker',
      'technical marker',
      'technicalmarker',
      'backend_failure',
      'backend-failure',
      'backend failure',
      'backendfailure',
      'unimplemented',
      'not_implemented',
      'not implemented',
      'not_supported',
      'not-supported',
      'not supported',
      'unsupported',
      'query_only',
      'query-only',
      'query only',
      'only_query',
      'only-query',
      'only query',
      'blocked',
      'block',
      'not_connected',
      'not-connected',
      'not connected',
      'notconnected',
      'route_unavailable',
      'route-unavailable',
      'route unavailable',
      'routeunavailable',
      'backend_blocked',
      'backendblocked',
      'backend-blocked',
      'backend blocked',
      'fail_closed',
      'failclosed',
      'fail-closed',
      'fail closed',
      'payment_backend_blocked',
      'paymentbackendblocked',
      'payment-backend-blocked',
      'payment backend blocked',
      'payment_status_unconfirmed',
      'paymentstatusunconfirmed',
      'payment-status-unconfirmed',
      'payment status unconfirmed',
      'unconfirmed',
      'action_blocked',
      'actionblocked',
      'action-blocked',
      'action blocked',
      'write_blocked',
      'writeblocked',
      'write blocked',
      'write-blocked',
      'false_proof',
      'falseproof',
      'false proof',
      'false-proof',
      'data_unavailable',
      'data-unavailable',
      'data unavailable',
      'need_login'
    ].includes(token) ||
    token.includes('mock') ||
    token.includes('fallback') ||
    token.includes('read_only') ||
    token.includes('read only') ||
    token.includes('read-only') ||
    token.includes('read_failure') ||
    token.includes('read-failure') ||
    token.includes('read failure') ||
    token.includes('readfailed') ||
    token.includes('read_failed') ||
    token.includes('read-failed') ||
    token.includes('read failed') ||
    token.includes('readblocked') ||
    token.includes('read_blocked') ||
    token.includes('read-blocked') ||
    token.includes('read blocked') ||
    token.includes('readunavailable') ||
    token.includes('read_unavailable') ||
    token.includes('read-unavailable') ||
    token.includes('read unavailable') ||
    token.includes('technical_error') ||
    token.includes('technical-error') ||
    token.includes('technical error') ||
    token.includes('technicalerror') ||
    token.includes('technical_exception') ||
    token.includes('technical-exception') ||
    token.includes('technical exception') ||
    token.includes('technicalexception') ||
    token.includes('technical_marker') ||
    token.includes('technical-marker') ||
    token.includes('technical marker') ||
    token.includes('technicalmarker') ||
    token.includes('backend_failure') ||
    token.includes('backend-failure') ||
    token.includes('backend failure') ||
    token.includes('backendfailure') ||
    token.includes('unimplemented') ||
    token.includes('not_implemented') ||
    token.includes('not implemented') ||
    token.includes('not_supported') ||
    token.includes('not-supported') ||
    token.includes('not supported') ||
    token.includes('unsupported') ||
    token.includes('query_only') ||
    token.includes('query-only') ||
    token.includes('query only') ||
    token.includes('only_query') ||
    token.includes('only-query') ||
    token.includes('only query') ||
    token.includes('not_connected') ||
    token.includes('not-connected') ||
    token.includes('not connected') ||
    token.includes('notconnected') ||
    token.includes('route_unavailable') ||
    token.includes('route-unavailable') ||
    token.includes('route unavailable') ||
    token.includes('routeunavailable') ||
    token.includes('backend_blocked') ||
    token.includes('backendblocked') ||
    token.includes('backend-blocked') ||
    token.includes('backend blocked') ||
    token.includes('fail_closed') ||
    token.includes('failclosed') ||
    token.includes('fail-closed') ||
    token.includes('fail closed') ||
    token.includes('payment_backend_blocked') ||
    token.includes('paymentbackendblocked') ||
    token.includes('payment-backend-blocked') ||
    token.includes('payment backend blocked') ||
    token.includes('payment_status_unconfirmed') ||
    token.includes('paymentstatusunconfirmed') ||
    token.includes('payment-status-unconfirmed') ||
    token.includes('payment status unconfirmed') ||
    token === 'unconfirmed' ||
    token.includes('action_blocked') ||
    token.includes('actionblocked') ||
    token.includes('action-blocked') ||
    token.includes('action blocked') ||
    token.includes('write_blocked') ||
    token.includes('writeblocked') ||
    token.includes('write blocked') ||
    token.includes('write-blocked') ||
    token.includes('false_proof') ||
    token.includes('falseproof') ||
    token.includes('false proof') ||
    token.includes('false-proof') ||
    token.includes('data_unavailable') ||
    token.includes('data-unavailable') ||
    token.includes('data unavailable') ||
    token.includes('need_login') ||
    token.includes('未接入') ||
    token.includes('只读') ||
    token.includes('不可用')
  )
}

function isActiveUnavailable(value) {
  if (value === true || value === 1) return true
  return ['true', '1', 'yes', 'on'].includes(markerToken(value)) || isUnavailableToken(value)
}

function firstNumber(values) {
  for (const value of values) {
    if (value === null || value === undefined || value === '') continue
    const number = Number(value)
    if (Number.isFinite(number) && number > 0) return number
  }
  return null
}

export function cryptoLotteryFamily(type) {
  const normalized = normalizedType(type)
  return CRYPTO_FAMILIES.find((family) => normalized.startsWith(family)) || null
}

export function isCryptoLotteryType(type) {
  return !!cryptoLotteryFamily(type)
}

export function isUnavailableLotteryCatalogEntry(entry) {
  const item = entry && typeof entry === 'object' ? entry : { lotteryType: entry }
  if (!item.lotteryType) return true
  if (isUnavailableToken(item.lotteryType)) return true
  if (item.success === false || markerToken(item.success) === 'false' || isUnavailableToken(item.success)) return true
  if (UNAVAILABLE_PROOF_KEYS.some(key => hasOwn(item, key) && (isFalseLike(item[key]) || isUnavailableToken(item[key])))) return true
  if (PAYMENT_STATUS_KEYS.some(key => hasOwn(item, key) && isUnavailableToken(item[key]))) return true
  if (UNAVAILABLE_FLAG_KEYS.some(key => hasOwn(item, key) && isActiveUnavailable(item[key]))) return true
  return UNAVAILABLE_TEXT_KEYS.some(key => hasOwn(item, key) && isUnavailableToken(item[key]))
}

export function filterPlayableLotteryEntries(list) {
  return (Array.isArray(list) ? list : []).filter(item => !isUnavailableLotteryCatalogEntry(item))
}

export function filterLotteryByTab(list, tabIndex) {
  const source = filterPlayableLotteryEntries(list)
  const familyByTab = {
    3: 'tron',
    4: 'eth',
    5: 'bnb'
  }
  const family = familyByTab[tabIndex]
  if (family) {
    return source.filter((item) => cryptoLotteryFamily(item && item.lotteryType) === family)
  }
  return source.filter((item) => item && item.freqType === 'H' && !isCryptoLotteryType(item.lotteryType))
}

export function lotteryJackpotMillion(item = {}) {
  const directMillion = firstNumber([
    item.jackpotMillion,
    item.jackpotMillions,
    item.jackpot_million,
    item.prizeMillion,
    item.prize_million
  ])
  if (directMillion !== null) return directMillion

  const rawAmount = firstNumber([
    item.jackpotAmount,
    item.jackpot_amount,
    item.prizePool,
    item.prize_pool,
    item.prizeAmount,
    item.prize_amount,
    item.maxBonusAmount,
    item.max_bonus_amount
  ])
  if (rawAmount === null) return null
  return rawAmount >= 100000 ? rawAmount / 1000000 : rawAmount
}
